import { render, staticRenderFns } from "./startElEden.vue?vue&type=template&id=e8e66090&"
import script from "./startElEden.vue?vue&type=script&lang=js&"
export * from "./startElEden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports